module.exports = __webpack_public_path__ + "img/resize-expand-sides.2483ef29.svg";